import { notificationTriggerEndpoints } from '@/modules/notification-center/event-trigger'
import TriggerStatusForm from '@/modules/notification-center/event-trigger/components/TriggerStatusForm.vue'
import { triggerPreviewComponents } from '@/modules/notification-center/event-trigger/helpers/previewComponents'
import { PopUpRouteConfig } from '@/shared/types/basePopUp'
import { RouteConfig } from 'vue-router'

const triggerPaths = {
  TRIGGERS: '/triggers',
  CONFIGURE_TRIGGER: '/triggers/configure/:id',
  PREVIEW_TRIGGER: '/triggers/view-details/:id',
  STATUS_TRACKING: '/triggers/:id/status_tracking'
}

/**
 * Trigger module routes
 */
export const triggerRoutes: RouteConfig[] = [
  {
    path: triggerPaths.TRIGGERS,
    name: 'triggers',
    component: () =>
      import(
        /* webpackChunkName: "TheTriggerChunk" */ '@/modules/notification-center/event-trigger/views/TheTrigger.vue'
      ),
    meta: {
      parentRouteName: null,
      title: 'navigations.triggerMetaTitle'
    }
  },
  {
    path: triggerPaths.PREVIEW_TRIGGER,
    name: 'preview-trigger',
    component: () =>
      import(
        /*ThePreviewTriggerChunk*/ '@/modules/notification-center/event-trigger/views/ThePreviewTrigger.vue'
      ),
    meta: {
      title: 'navigations.triggerMetaTitle',
      parentRouteName: 'triggers',
      logPage: {
        endpoint: notificationTriggerEndpoints,
        previewDynamicComponents: triggerPreviewComponents
      }
    }
  },
  {
    path: triggerPaths.CONFIGURE_TRIGGER,
    name: 'configure-trigger',
    component: () =>
      import(
        /* webpackChunkName: "TheConfigureTrigger" */ '@/modules/notification-center/event-trigger/views/TheConfigureTrigger.vue'
      ),
    meta: {
      title: 'navigations.triggerMetaTitle',
      parentRouteName: 'triggers'
    }
  },
  {
    path: triggerPaths.STATUS_TRACKING,
    name: 'status-tracking',
    component: () =>
      import(
        /* webpackChunkName: "TheStatusTracking" */ '@/modules/notification-center/event-trigger/views/TheStatusTracking.vue'
      ),
    meta: {
      title: 'navigations.triggerMetaTitle',
      parentRouteName: 'triggers'
    }
  }
]

export const triggerModalRoutes: PopUpRouteConfig[] = [
  {
    component: TriggerStatusForm,
    dialogTitle: 'Change Trigger Status',
    size: 500,
    persistent: true,
    name: 'change-status',
    requiredParams: ['id']
  }
]
